@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="m-2 owner-profile-container">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button (click)="closePopUpOfQuote()" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
    <mat-tab-group class="tabs-group">
      <mat-tab label="Profile Detail">
        <div>

          <div [formGroup]="form1" class="forms w-100 d-block">
            <div class="row">

              <div>
                @if (formAlert) {
                  <div class="w-100 mb-3">
                    <div class="w-100"
                      style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                      <p><b>{{formAlert}}</b></p>
                    </div>
                  </div>
                }
              </div>


              @if (ownerProfileId) {
                <hr>
                }
                <div class="col-md-6">
                  <span class="p-float-label required-field w-100 mb-3">
                    <p-dropdown [options]="listingStatus" formControlName="listingStatus" optionLabel="name"
                      optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
                    placeholder="Select Status" [dropdownIcon]="'fa fa-caret-down'" required></p-dropdown>
                    <label for="Select Status">Select Status</label>
                    @for (validation of validationMessages.listingStatus; track validation) {
                      <span>
                        @if (form1.get('listingStatus').hasError(validation.type) && (form1.get('listingStatus').dirty || form1.get('listingStatus').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                @if (isDisplayPropertyProfile) {
                  <div class="col-md-2 d-flex justify-content-end">
                    <label>Portal Access : </label>
                  </div>
                }
                @if (isDisplayPropertyProfile) {
                  <div class="col-md-4">
                    <span class="p-float-label required-field w-100 mb-3">
                      <p-inputSwitch (onChange)="updateOwnerPortalAccess()"
                        formControlName="portalAccessBasic">
                      </p-inputSwitch>
                      @for (validation of validationMessages.portalAccessBasic; track validation) {
                        <span>
                          @if (form1.get('portalAccessBasic').hasError(validation.type) && (form1.get('portalAccessBasic').dirty || form1.get('portalAccessBasic').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>
                }

                <!-- <div class="row d-flex"> -->
                @if (ownerProfile?.ownerProfileId != undefined) {
                  <div class="col-md-6">
                    <span class="p-float-label required-field w-100 mb-4">
                      @if (propertyProfilesList != undefined && propertyProfilesList.length > 0) {
                        <p-multiSelect
                          [options]="propertyProfilesList" formControlName="propertyProfileVOList"
                          (onChange)="updatePropertyProfileOfPropertyProfile()" appendTo="body"
                        defaultLabel="Select Property Profile" optionLabel="propertyName"></p-multiSelect>
                      }
                      <label for="Select Property Profile">Select Property Profile</label>
                      @for (validation of validationMessages.propertyProfileVOList; track validation) {
                        <span>
                          @if (form1.get('propertyProfileVOList').hasError(validation.type) && (form1.get('propertyProfileVOList').dirty || form1.get('propertyProfileVOList').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>
                }

                @if (!isDisplayPropertyProfile) {
                  <div class="col-md-6"></div>
                }

                <!-- <div *ngIf="ownerProfile?.ownerProfileId == undefined" class="col-12 row py-0"> -->
                @if (ownerProfile?.ownerProfileId == undefined) {
                  <div class="col-md-6">
                    <span class="p-float-label required-field w-100 mb-4">
                      @if (propertyProfilesList != undefined && propertyProfilesList.length > 0) {
                        <p-multiSelect
                          class="lead-select" [options]="propertyProfilesList"
                          formControlName="propertyProfileVOList" appendTo="body"
                        defaultLabel="Select Property Profile" optionLabel="propertyName"></p-multiSelect>
                      }
                      <label for="Select Property Profile">Select Property Profile</label>
                      @for (validation of validationMessages.propertyProfileVOList; track validation) {
                        <span>
                          @if (form1.get('propertyProfileVOList').hasError(validation.type) && (form1.get('propertyProfileVOList').dirty || form1.get('propertyProfileVOList').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>
                }
                <div class="col-6 py-0 d-flex justify-content-start align-items-center">
                  <button class="btn btn-icon btn-success rounded-pill mb-4" (click)="formAddPropertyLead()">
                    <i class="pi pi-plus"></i>
                  </button>
                </div>
              <!-- </div> -->

            <!-- </div> -->

            @if (ownerProfile?.ownerProfileId != undefined) {
              <div class="col-md-4">
                <span class="p-float-label required-field w-100 mb-3">
                  <p-table [value]="ownerProfile?.propertyProfileVOList"
                    [tableStyle]="{ 'min-width': 'auto' }">
                    <ng-template pTemplate="header">
                      <tr>
                        <th [ngStyle]="{'width': 'auto'}">Property Name</th>
                        <th [ngStyle]="{'width': 'auto'}"></th>
                        <th [ngStyle]="{'width': 'auto'}"></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-propertyProfile>
                      <tr>
                        <td>
                          {{ propertyProfile.propertyName }}
                        </td>
                        <td>
                          <span style="float:none">
                            <a>
                              <i class="pi pi-pencil" aria-hidden="true"
                                style="color:blue; font-size:110%;"
                              (click)="fetchPropertyProfileById(propertyProfile)"></i>
                            </a>
                          </span>
                        </td>
                        <td>
                          <span style="float:none">
                            <a>
                              <i class="pi pi-trash" aria-hidden="true"
                                style="color:red; font-size:110%; padding-right:5px;"
                              (click)="deletePropertyAndOwnerProfile(propertyProfile)"></i>
                            </a>
                          </span>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </span>
              </div>
            }
            <div class="col-md-6">
              <!-- <p-checkbox [formControl]="form1.controls['profileActive']" inputId="profileActive" [binary]="true"></p-checkbox> -->
              @if (profileActive == true) {
                <span><i class="pi pi-check"
                style="color: green;font-size: 1rem"></i></span>
              }
              @if (profileActive == false) {
                <span><i class="pi pi-times"
                style="color: red;font-size: 1rem"></i></span>
              }
              <span class="test-nm ms-3" style="color:black">Is owner profile Active?</span><br>

              @if (havePortalAccess == true) {
                <span><i class="pi pi-check"
                style="color: green;font-size: 1rem"></i></span>
              }
              @if (havePortalAccess == false) {
                <span><i class="pi pi-times"
                style="color: red;font-size: 1rem"></i></span>
              }
              <span class="test-nm ms-3" style="color:black">Is the portal access ON?</span><br>

              @if (onlyOneEmailAddress == true) {
                <span><i class="pi pi-check"
                style="color: green;font-size: 1rem"></i></span>
              }
              @if (onlyOneEmailAddress == false) {
                <span><i class="pi pi-times"
                style="color: red;font-size: 1rem"></i></span>
              }
              <span class="test-nm ms-3" style="color:black">Is there only one instance of the email
              address in homeownerprofile?</span><br>

              @if (haveOwnerProperty == true) {
                <span><i class="pi pi-check"
                style="color: green;font-size: 1rem"></i></span>
              }
              @if (haveOwnerProperty == false) {
                <span><i class="pi pi-times"
                style="color: red;font-size: 1rem"></i></span>
              }
              <span class="test-nm ms-3" style="color:black">Is their one or more property profiles
              assigned to the homeowner profile?</span><br>

              @if (propProfileHaveShortTermRental == true) {
                <span><i class="pi pi-check"
                style="color: green;font-size: 1rem"></i></span>
              }
              @if (propProfileHaveShortTermRental == false) {
                <span><i class="pi pi-times"
                style="color: red;font-size: 1rem"></i></span>
              }
              <span class="test-nm ms-3" style="color:black">Is there a shortTermRental slected for each
              property profile?</span><br>

              @if (shortTermRentalHaveSlPropertyId == true) {
                <span><i class="pi pi-check"
                style="color: green;font-size: 1rem"></i></span>
              }
              @if (shortTermRentalHaveSlPropertyId == false) {
                <span><i class="pi pi-times"
                style="color: red;font-size: 1rem"></i></span>
              }
              <span class="test-nm ms-3" style="color:black">is there a slPropertyId in the channel tab
              for each shortTermRental?</span><br>
              <!-- checkOwnerHaveHomeOwnerPortalRole -->
              <!-- <span *ngIf="checkOwnerHaveHomeOwnerPortalRole == true"><i class="pi pi-check" style="color: green;font-size: 1rem"></i></span>
              <span *ngIf="checkOwnerHaveHomeOwnerPortalRole == false"><i class="pi pi-times" style="color: red;font-size: 1rem"></i></span>
              <span class="test-nm ms-3" style="color:black">is the user role 1200 present?</span> -->
            </div>

            <div class="col-md-2">
              <div class="ctm_img ownerprofileimg" style="display: flex;height: 100%;">
                <!-- <img *ngIf="pictureUrl" src="{{generateUrl(pictureUrl)}}" alt="hotel-pool" style="width:100%;height:100%;object-fit: cover;"> -->
                @if (pictureUrl) {
                  <img src="{{pictureUrl}}" alt="hotel-pool"
                    style="width:100%;height:100%;object-fit: cover;">
                }
                @if (!pictureUrl) {
                  <img href="javascript:void(0)" alt="Upload profile picture"
                    style="width:100%;height:100%;object-fit: cover;">
                }
                <a (click)="openDialogUploadImage()">
                  <i class="pi pi-pencil"></i>
                </a>
              </div>
            </div>
          </div>

          <div class="row my-3">
            <div class="col-md-8">
              <div>
                <div>
                  <div class="mb-3 fw-bold title">Contact</div>

                  <div>
                    <div class="row">

                      <div class="col-md-2">
                        <div class="p-float-label required-field mb-3" >
                          <p-dropdown [options]="titles" formControlName="title" optionLabel="name" optionValue="value" [filter]="true" styleClass="w-100"
                          filterBy="value" [showClear]="false" placeholder="Title" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                          <label for="title">Title</label>
                          @for (validation of validationMessages.title; track validation) {
                            <span>
                              @if (form1.get('title').hasError(validation.type) && (form1.get('title').dirty || form1.get('title').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>



                      <div class="col-md-2">
                        <div class="p-float-label required-field mb-3" >
                          <input formControlName="firstName" id="firstName" [required]="true" type="text" pInputText class="w-100">
                          <label for="firstName">First Name</label>
                          @for (validation of validationMessages.firstName; track validation) {
                            <span>
                              @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="p-float-label mb-3" >
                          <input formControlName="middleName" id="middleName" type="text" pInputText class="w-100">
                          <label for="middleName">Middle Name</label>
                          @for (validation of validationMessages.middleName; track validation) {
                            <span>
                              @if (form1.get('middleName').hasError(validation.type) && (form1.get('middleName').dirty || form1.get('middleName').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="p-float-label required-field mb-3">
                          <input formControlName="lastName" id="lastName" [required]="true" type="text" pInputText class="w-100">
                          <label for="lastName">Last Name</label>
                          @for (validation of validationMessages.lastName; track validation) {
                            <span>
                              @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>

                      <div class="col-md-2">
                        <div class="p-float-label mb-3">
                          <input formControlName="suffix" id="suffix" type="text" pInputText class="w-100">
                          <label for="suffix">suffix</label>
                          @for (validation of validationMessages.suffix; track validation) {
                            <span>
                              @if (form1.get('suffix').hasError(validation.type) && (form1.get('suffix').dirty || form1.get('suffix').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <div class="p-float-label mb-3">
                          <input formControlName="companyName" class="w-100" id="companyName" type="text" pInputText>
                          <label for="companyName">Company Name</label>
                          @for (validation of validationMessages.companyName; track validation) {
                            <span>
                              @if (form1.get('companyName').hasError(validation.type) && (form1.get('companyName').dirty || form1.get('companyName').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="p-float-label required-field mb-3">
                          <input formControlName="emailAddress" class="w-100" id="emailAddress" [required]="true" type="text" pInputText>
                          <label for="emailAddress">Email Address</label>
                          @for (validation of validationMessages.emailAddress; track validation) {
                            <span>
                              @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="p-float-label required-field mb-3">
                          <input formControlName="emailAddress2" class="w-100" id="emailAddress2" [required]="false" type="text" pInputText>
                          <label for="emailAddress2">Email Address 2</label>
                          @for (validation of validationMessages.emailAddress2; track validation) {
                            <span>
                              @if (form1.get('emailAddress2').hasError(validation.type) && (form1.get('emailAddress2').dirty || form1.get('emailAddress2').touched)) {
                                <small class="p-invalid"
                                  >{{validation.message}}
                                </small>
                              }
                            </span>
                          }
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-3">
                        <span class="p-float-label mb-3">
                          <!-- <p-inputMask formControlName="mobilePhone" id="mobilePhone" mask="(999) 999-9999" type="text">
                        </p-inputMask> -->
                        <input formControlName="mobilePhone" class="w-100" id="mobilePhone" type="text" pInputText>
                        <label for="mobilePhone">Mobile Phone</label>
                        @for (validation of validationMessages.mobilePhone; track validation) {
                          <span>
                            @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                    <div class="col-md-3">
                      <span class="p-float-label mb-3">
                        <p-dropdown  styleClass="w-100" [options]="contactPrefs" formControlName="contactPref" optionLabel="name"
                          appendTo="body" optionValue="value" [filter]="true" filterBy="value" [showClear]="false"
                        placeholder="Select Contact" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                        <label for="Select Contact">Select Contact</label>
                        @for (validation of validationMessages.contactPref; track validation) {
                          <span>
                            @if (form1.get('contactPref').hasError(validation.type) && (form1.get('contactPref').dirty || form1.get('contactPref').touched)) {
                              <small class="p-invalid"
                                >{{validation.message}}
                              </small>
                            }
                          </span>
                        }
                      </span>
                    </div>
                  </div>

                </div>
              </div>

              <!-- <div class="col-md-6">
              <span class="p-float-label required-field w-100 mb-3">
                <p-multiSelect [options]="properties" formControlName="shortTermRentals" defaultLabel="Select Property" optionLabel="propertyCode" display="chip"></p-multiSelect>
                <span *ngFor="let validation of validationMessages.shortTermRentals">
                  <small class="p-invalid"
                    *ngIf="form1.get('shortTermRentals').hasError(validation.type) && (form1.get('shortTermRentals').dirty || form1.get('shortTermRentals').touched)">{{validation.message}}
                  </small>
                </span>
              </span>
            </div> -->

            <div>
              <div class="mb-3 fw-bold title">Spouse Contact</div>

              <div>
                <div class="row">
                  <div class="col-md-3">
                    <span class="p-float-label required-field mb-3">
                      <input class="w-100" formControlName="spouseFirstName" id="spouseFirstName" type="text" pInputText>
                      <label for="spouseFirstName">Spouse First Name</label>
                      @for (validation of validationMessages.spouseFirstName; track validation) {
                        <span>
                          @if (form1.get('spouseFirstName').hasError(validation.type) && (form1.get('spouseFirstName').dirty || form1.get('spouseFirstName').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>

                  <div class="col-md-3">
                    <span class="p-float-label required-field mb-3">
                      <input class="w-100" formControlName="spouseLastName" id="spouseLastName" type="text" pInputText>
                      <label for="spouseLastName">Spouse Last Name</label>
                      @for (validation of validationMessages.spouseLastName; track validation) {
                        <span>
                          @if (form1.get('spouseLastName').hasError(validation.type) && (form1.get('spouseLastName').dirty || form1.get('spouseLastName').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-3">
                    <span class="p-float-label mb-3">
                      <input class="w-100" formControlName="spouseEmailAdress" id="spouseEmailAdress" type="text" pInputText>
                      <label for="spouseEmailAdress">Spouse Email Address</label>
                      @for (validation of validationMessages.spouseEmailAdress; track validation) {
                        <span>
                          @if (form1.get('spouseEmailAdress').hasError(validation.type) && (form1.get('spouseEmailAdress').dirty || form1.get('spouseEmailAdress').touched)) {
                            <small class="p-invalid"
                              >{{validation.message}}
                            </small>
                          }
                        </span>
                      }
                    </span>
                  </div>

                  <div class="col-md-3">
                    <span class="p-float-label mb-3">
                      <!-- <p-inputMask formControlName="spouseMobile" id="spouseMobile" mask="(999) 999-9999" type="text">
                    </p-inputMask> -->
                    <input class="w-100" formControlName="spouseMobile" id="spouseMobile" type="text" pInputText>
                    <label for="spouseMobile">Spouse Mobile Phone</label>
                    @for (validation of validationMessages.spouseMobile; track validation) {
                      <span>
                        @if (form1.get('spouseMobile').hasError(validation.type) && (form1.get('spouseMobile').dirty || form1.get('spouseMobile').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <span class="p-float-label mb-3">
                    <textarea class="w-100" formControlName="spouseOpsNotes" id="spouseOpsNotes" [rows]="2" pInputTextarea></textarea>
                    <label for="spouseOpsNotes">Spouse Ops Notes</label>
                    @for (validation of validationMessages.spouseOpsNotes; track validation) {
                      <span>
                        @if (form1.get('spouseOpsNotes').hasError(validation.type) && (form1.get('spouseOpsNotes').dirty || form1.get('spouseOpsNotes').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>


          <div>
            <div class="mb-3 fw-bold title">Profile</div>



            <div>
              <div class="row">
                <div class="col-md-3">
                  <span class="p-float-label mb-3">
                    <p-calendar styleClass="w-100" appendTo="body" formControlName="anniversaryDate" inputId="anniversaryDate" appendTo="body">
                    </p-calendar>
                    <label for="anniversaryDate">Anniversary Date</label>
                    @for (validation of validationMessages.anniversaryDate; track validation) {
                      <span>
                        @if (form1.get('anniversaryDate').hasError(validation.type) && (form1.get('anniversaryDate').dirty || form1.get('anniversaryDate').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-md-3">
                  <span class="p-float-label mb-3">
                    <p-calendar styleClass="w-100" appendTo="body" formControlName="birthDate" inputId="birthDate" appendTo="body">
                    </p-calendar>
                    <label for="birthDate">Birth Date</label>
                    @for (validation of validationMessages.birthDate; track validation) {
                      <span>
                        @if (form1.get('birthDate').hasError(validation.type) && (form1.get('birthDate').dirty || form1.get('birthDate').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>


              <div class="row">
                <div class="col-md-6">
                  <span class="p-float-label mb-3">
                    <textarea class="w-100" formControlName="opsNotes" id="opsNotes" [rows]="2" pInputTextarea></textarea>
                    <label for="opsNotes">Ops Notes</label>
                    @for (validation of validationMessages.opsNotes; track validation) {
                      <span>
                        @if (form1.get('opsNotes').hasError(validation.type) && (form1.get('opsNotes').dirty || form1.get('opsNotes').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <span class="p-float-label mb-3">
                    <textarea class="w-100" formControlName="arrivalPrepDesc" id="arrivalPrepDesc" [rows]="2" pInputTextarea></textarea>
                    <label for="arrivalPrepDesc">Arrival Prep Description</label>
                    @for (validation of validationMessages.arrivalPrepDesc; track validation) {
                      <span>
                        @if (form1.get('arrivalPrepDesc').hasError(validation.type) && (form1.get('arrivalPrepDesc').dirty || form1.get('arrivalPrepDesc').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>



              <div class="row">
                <div class="col-md-6">
                  <span class="p-float-label mb-3">
                    <textarea class="w-100" formControlName="favSports" id="favSports" [rows]="2" pInputTextarea></textarea>
                    <label for="favSports">Favorite Sports</label>
                    @for (validation of validationMessages.favSports; track validation) {
                      <span>
                        @if (form1.get('favSports').hasError(validation.type) && (form1.get('favSports').dirty || form1.get('favSports').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <span class="p-float-label mb-3">
                    <textarea class="w-100" formControlName="education" id="education" [rows]="2" pInputTextarea></textarea>
                    <label for="education">Education</label>
                    @for (validation of validationMessages.education; track validation) {
                      <span>
                        @if (form1.get('education').hasError(validation.type) && (form1.get('education').dirty || form1.get('education').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <span class="p-float-label mb-3">
                    <textarea class="w-100" formControlName="politics" id="politics" [rows]="2" pInputTextarea></textarea>
                    <label for="politics">Politics</label>
                    @for (validation of validationMessages.politics; track validation) {
                      <span>
                        @if (form1.get('politics').hasError(validation.type) && (form1.get('politics').dirty || form1.get('politics').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <span class="p-float-label mb-3">
                    <textarea class="w-100" formControlName="foodAndBevPrefs" id="foodAndBevPrefs" [rows]="2" pInputTextarea></textarea>
                    <label for="foodAndBevPrefs">Food And BevPrefs</label>
                    @for (validation of validationMessages.foodAndBevPrefs; track validation) {
                      <span>
                        @if (form1.get('foodAndBevPrefs').hasError(validation.type) && (form1.get('foodAndBevPrefs').dirty || form1.get('foodAndBevPrefs').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <span class="p-float-label mb-3">
                    <textarea class="w-100" formControlName="localVehicleDesc" id="localVehicleDesc" [rows]="2" pInputTextarea></textarea>
                    <label for="localVehicleDesc">Local Vehicle Desc</label>
                    @for (validation of validationMessages.localVehicleDesc; track validation) {
                      <span>
                        @if (form1.get('localVehicleDesc').hasError(validation.type) && (form1.get('localVehicleDesc').dirty || form1.get('localVehicleDesc').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div class="mb-3 fw-bold title">Mail Address</div>

            <div>

              <div class="row">
                <div class="col-md-4">
                  <span class="p-float-label mb-3">
                    <input class="w-100" formControlName="mailAdrCompanyName" id="mailAdrCompanyName" type="text" pInputText>
                    <label for="mailAdrCompanyName">Mail Address Company Name</label>
                    @for (validation of validationMessages.mailAdrCompanyName; track validation) {
                      <span>
                        @if (form1.get('mailAdrCompanyName').hasError(validation.type) && (form1.get('mailAdrCompanyName').dirty || form1.get('mailAdrCompanyName').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
                <div class="col-md-4">
                  <span class="p-float-label mb-3">
                    <input class="w-100" formControlName="mailAdrStreet" id="mailAdrStreet" type="text" pInputText>
                    <label for="mailAdrStreet">Mail Address Street</label>
                    @for (validation of validationMessages.mailAdrStreet; track validation) {
                      <span>
                        @if (form1.get('mailAdrStreet').hasError(validation.type) && (form1.get('mailAdrStreet').dirty || form1.get('mailAdrStreet').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-md-4">
                  <span class="p-float-label mb-3">
                    <input class="w-100" formControlName="mailAdrStreet2" id="mailAdrStreet2" type="text" pInputText>
                    <label for="mailAdrStreet2">Mail Address Street2</label>
                    @for (validation of validationMessages.mailAdrStreet2; track validation) {
                      <span>
                        @if (form1.get('mailAdrStreet2').hasError(validation.type) && (form1.get('mailAdrStreet2').dirty || form1.get('mailAdrStreet2').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <span class="p-float-label mb-3">
                    <input class="w-100" formControlName="mailAdrCity" id="mailAdrCity" type="text" pInputText>
                    <label for="mailAdrCity">Mail Address City</label>
                    @for (validation of validationMessages.mailAdrCity; track validation) {
                      <span>
                        @if (form1.get('mailAdrCity').hasError(validation.type) && (form1.get('mailAdrCity').dirty || form1.get('mailAdrCity').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-md-3">
                  <span class="p-float-label mb-3">
                    <p-dropdown styleClass="w-100" [options]="states" formControlName="mailAdrState" optionLabel="name" appendTo="body"
                      optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false" placeholder="State" [dropdownIcon]="'fa fa-caret-down'">
                    </p-dropdown>
                    <label for="State">State</label>
                    @for (validation of validationMessages.mailAdrState; track validation) {
                      <span>
                        @if (form1.get('mailAdrState').hasError(validation.type) && (form1.get('mailAdrState').dirty || form1.get('mailAdrState').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-md-2">
                  <span class="p-float-label mb-3">
                    <input class="w-100" formControlName="mailAdrPostalCode" id="mailAdrPostalCode" type="text" pInputText>
                    <label for="mailAdrPostalCode">Postal Code</label>
                    @for (validation of validationMessages.mailAdrPostalCode; track validation) {
                      <span>
                        @if (form1.get('mailAdrPostalCode').hasError(validation.type) && (form1.get('mailAdrPostalCode').dirty || form1.get('mailAdrPostalCode').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>

                <div class="col-md-3">
                  <span class="p-float-label mb-3">
                    <p-dropdown appendTo="body" styleClass="w-100" [options]="countries" formControlName="mailAdrCountry" optionLabel="name" appendTo="body"
                      optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false" placeholder="Country" [dropdownIcon]="'fa fa-caret-down'">
                    </p-dropdown>
                    <label for="Country">Country</label>
                    @for (validation of validationMessages.mailAdrCountry; track validation) {
                      <span>
                        @if (form1.get('mailAdrCountry').hasError(validation.type) && (form1.get('mailAdrCountry').dirty || form1.get('mailAdrCountry').touched)) {
                          <small class="p-invalid"
                            >{{validation.message}}
                          </small>
                        }
                      </span>
                    }
                  </span>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <span class="p-float-label mb-3">
                    <!-- <p-inputMask formControlName="mailAdrPhone" id="mailAdrPhone" mask="(999) 999-9999" type="text">
                  </p-inputMask> -->
                  <input class="w-100" formControlName="mailAdrPhone" id="mailAdrPhone" type="text" pInputText>
                  <label for="mailAdrPhone">Mail Address Phone</label>
                  @for (validation of validationMessages.mailAdrPhone; track validation) {
                    <span>
                      @if (form1.get('mailAdrPhone').hasError(validation.type) && (form1.get('mailAdrPhone').dirty || form1.get('mailAdrPhone').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-md-3">
                <span class="p-float-label mb-3">
                  <input class="w-100" formControlName="mailAdrFax" id="mailAdrFax" type="text" pInputText>
                  <label for="mailAdrFax">Mail Address Fax</label>
                  @for (validation of validationMessages.mailAdrFax; track validation) {
                    <span>
                      @if (form1.get('mailAdrFax').hasError(validation.type) && (form1.get('mailAdrFax').dirty || form1.get('mailAdrFax').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-md-3">
                <span class="p-float-label mb-3">
                  <p-calendar styleClass="w-100" appendTo="body" formControlName="contractSignDate" inputId="contractSignDate" appendTo="body">
                  </p-calendar>
                  <label for="contractSignDate">Contract Sign Date</label>
                  @for (validation of validationMessages.contractSignDate; track validation) {
                    <span>
                      @if (form1.get('contractSignDate').hasError(validation.type) && (form1.get('contractSignDate').dirty || form1.get('contractSignDate').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              
            </div>

            

            <div class="row">
              <div class="col-md-12">
                <span class="p-float-label mb-3">
                  <textarea formControlName="aboutOwner" id="aboutOwner" class="w-100" [rows]="3" pInputTextarea></textarea>
                  <label for="aboutOwner">About Owner</label>
                  @for (validation of validationMessages.aboutOwner; track validation) {
                    <span>
                      @if (form1.get('aboutOwner').hasError(validation.type) && (form1.get('aboutOwner').dirty || form1.get('aboutOwner').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="mb-3 fw-bold title">Others</div>

          <div class="row">
            <div class="col-md-3">
              <span class="p-float-label mb-3">
                <p-dropdown styleClass="w-100" [options]="engagementFreqOptions" formControlName="engagementFreq" optionLabel="name"
                optionValue="value" placeholder="Engagement Frequency" appendTo="body" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                <label for="engagementFreq">Engagement Frequency</label>
                @for (validation of validationMessages.engagementFreq; track validation) {
                  <span>
                    @if (form1.get('engagementFreq').hasError(validation.type) && (form1.get('engagementFreq').dirty || form1.get('engagementFreq').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div class="col-md-3">
              <span class="p-float-label mb-3">
                <p-dropdown styleClass="w-100" [options]="ownerQualityOptions" formControlName="ownerQuality" optionLabel="name"
                optionValue="value" placeholder="Owner Quality" appendTo="body" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                <label for="ownerQuality">Owner Quality</label>
                @for (validation of validationMessages.ownerQuality; track validation) {
                  <span>
                    @if (form1.get('ownerQuality').hasError(validation.type) && (form1.get('ownerQuality').dirty || form1.get('ownerQuality').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div class="col-md-3">
              <span class="p-float-label mb-3">
                <p-dropdown styleClass="w-100" [options]="satisfactionRanks" formControlName="satisfactionRank" optionLabel="name"
                optionValue="value" placeholder="Satisfaction Rank" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                <label for="satisfactionRank">Satisfaction Rank</label>
                @for (validation of validationMessages.satisfactionRank; track validation) {
                  <span>
                    @if (form1.get('satisfactionRank').hasError(validation.type) && (form1.get('satisfactionRank').dirty || form1.get('satisfactionRank').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div class="col-md-3">
              <span class="p-float-label mb-3">
                <p-dropdown styleClass="w-100" [options]="temperaments" formControlName="temperament" optionLabel="name"
                optionValue="value" placeholder="Temperament" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                <label for="temperament">Temperament</label>
                @for (validation of validationMessages.temperament; track validation) {
                  <span>
                    @if (form1.get('temperament').hasError(validation.type) && (form1.get('temperament').dirty || form1.get('temperament').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

          </div>

          <div class="row">
            <div class="col-md-3">
              <span class="p-float-label mb-3">
                <p-dropdown styleClass="w-100" [options]="incomeSensitivities" formControlName="incomeSensitivity" optionLabel="name"
                optionValue="value" placeholder="Income Sensitivity" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                <label for="incomeSensitivity">Income Sensitivity</label>
                @for (validation of validationMessages.incomeSensitivity; track validation) {
                  <span>
                    @if (form1.get('incomeSensitivity').hasError(validation.type) && (form1.get('incomeSensitivity').dirty || form1.get('incomeSensitivity').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-md-3">
              <span class="p-float-label mb-3">
                <p-dropdown styleClass="w-100" [options]="maintenanceSensitivities" formControlName="maintenanceSensitivity"
                optionLabel="name" optionValue="value" placeholder="Maintenance Sensitivity" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                <label for="maintenanceSensitivity">Maintenance Sensitivity</label>
                @for (validation of validationMessages.maintenanceSensitivity; track validation) {
                  <span>
                    @if (form1.get('maintenanceSensitivity').hasError(validation.type) && (form1.get('maintenanceSensitivity').dirty || form1.get('maintenanceSensitivity').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>

            <div class="col-md-3">
              <span class="p-float-label mb-3">
                <p-dropdown styleClass="w-100" [options]="numbers" [autoDisplayFirst]="true" formControlName="compHostNights" optionLabel="name"
                optionValue="value" [dropdownIcon]="'fa fa-caret-down'"></p-dropdown>
                <label for="compHostNights">Influencer</label>
                @for (validation of validationMessages.compHostNights; track validation) {
                  <span>
                    @if (form1.get('compHostNights').hasError(validation.type) && (form1.get('compHostNights').dirty || form1.get('compHostNights').touched)) {
                      <small id="compHostNights-help" class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      @if (ownerProfileId) {
        <div style="margin-bottom: 10px">
          <app-notes-chat [config]="notesChatConfig" [noteSourceId]="ownerProfileId" [noteSource]="50"></app-notes-chat>
        </div>
      }
    </div>
  </div>
</div>
@if (ownerProfileId) {
  <div>
    <div class="col-md-12">
      <h6>Owner Profile Guest</h6>
    </div>
    <hr>
      <app-owner-profile-guest-list [ownerProfileId]="ownerProfileId" [showFilter]="false"
        [showPagination]="false">
      </app-owner-profile-guest-list>
    </div>
  }

  @if (ownerProfileId) {
    <hr>
    }
    @if (ownerProfileId) {
      <div class="col-md-6">
        <app-tag-join-select [tagSource]="50" [tagSourceId]="ownerProfileId" tagType="4">
        </app-tag-join-select>
      </div>
    }

    <hr>
      <div class="row m-0">
        <div class="col-md-12">
          <div class="btn-group">
            <div class="button-group">
              @if (ownerProfileId) {
                <button pButton
                  class="btn-delete p-button-outlined p-button-danger" (click)="onFormDelete()">Delete
                OwnerProfile</button>
              }
            </div>

            <div class="button-group">
              <button pButton class="btn-cancel p-button-text"
              [mat-dialog-close]="true">Cancel</button>
              @if (!ownerProfileId) {
                <button pButton class="btn-addt p-button"
                (click)="formAdd()">Add OwnerProfile</button>
              }

              @if (ownerProfileId) {
                <button pButton class="btn-upt p-button"
                (click)="formUpdate()">Update OwnerProfile</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
  <mat-tab label="Owner Communication">
    <app-inbox-list-vertical [msgTopic]="500" [msgTemplateData]="msgTemplateData"
    [msgTopicId]="ownerProfile?.ownerProfileId"></app-inbox-list-vertical>
  </mat-tab>
</mat-tab-group>
</div>

<p-dialog header="Upload Profile Picture" [(visible)]="visible" [style]="{width: '50vw'}">
  <div class="col-md-12">
    <span class="p-float-label w-100 mb-3">
      <p-fileUpload mode="basic" chooseLabel="Choose File" name="files[]" [customUpload]="true"
        (uploadHandler)="myUploader($event)" accept=".jpg,.jpeg,.gif" maxFileSize="52428800">
        <ng-template pTemplate="content">
          @if (uploadedFiles.length) {
            <ul>
              @for (file of uploadedFiles; track file) {
                <li>{{file.name}} - {{file.size}} bytes
                </li>
              }
            </ul>
          }
        </ng-template>
      </p-fileUpload>
    </span>
  </div>
</p-dialog>